var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Falcon } from 'modules/macro';
import { Box } from 'modules/v2/foundation/Box';
import { Container, IconContainer, ContentContainer, StyledMessage, StyledTitle } from './styled';
export function Alert(props) {
    const { appearance, title, message, children } = props, rest = __rest(props, ["appearance", "title", "message", "children"]);
    const iconMap = {
        success: <Falcon $size={18} icon="circle-check" sourceConfig={{ family: 'classic', style: 'solid' }}/>,
        info: <Falcon $size={18} icon="info-circle" sourceConfig={{ family: 'classic', style: 'solid' }}/>,
        warning: <Falcon $size={18} icon="exclamation-triangle" sourceConfig={{ family: 'classic', style: 'solid' }}/>,
        danger: <Falcon $size={18} icon="circle-xmark" sourceConfig={{ family: 'classic', style: 'solid' }}/>,
    };
    return (<Container role="alert" $onlyMessage={!title && !children} {...rest}>
      <IconContainer $appearance={appearance}>{iconMap[appearance]}</IconContainer>
      <ContentContainer>
        {title && (<StyledTitle $fontWeight="semibold" $fontSize="small" $appearance="200">
            {title}
          </StyledTitle>)}
        <StyledMessage $fontWeight="regular" $fontSize="small" $appearance="100">
          {message}
        </StyledMessage>
        {children && (<Box flexDirection="row" gap="md" mt="md">
            {children}
          </Box>)}
      </ContentContainer>
    </Container>);
}
